export const creditScore = [
  {
    value: "720+",
    name: "720+",
  },
  {
    value: "660 - 719",
    name: "660 - 719",
  },
  {
    value: "620 - 659",
    name: "620 - 659",
  },
  {
    value: "580 - 619",
    name: "580 - 619",
  },
  {
    value: "500 - 579",
    name: "500 - 579",
  },
  {
    value: "< 500",
    name: "< 500",
  },
];



// WEBPACK FOOTER //
// ./src/constants/creditScore.js